import React, { useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './components/ThemeProvider';
import { LanguageProvider } from './components/LanguageProvider';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import UrunBolumleri from './components/urun';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Security from './components/Security';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SectionReveal from './components/SectionReveal';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import DataProtectionPage from './pages/DataProtectionPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CloudPage from './pages/CloudPage';

/* Scroll to top on route change — prevents staying mid-page after navigation.
   ANINDA, ilk çizimden ÖNCE (2 Ekim 2026): App.css'teki
   `html { scroll-behavior: smooth }` yüzünden düz `window.scrollTo(0, 0)` bir
   animasyona dönüşüyordu; ölçümde footer'dan açılan sözleşme sayfası ~8.000 px
   aşağıdan (sonundan) görünüp 0,75 sn boyunca yukarı kayıyordu. Kural bir
   anlığına kapatılır (eski tarayıcılar `behavior: 'instant'`i tanımayabilir);
   Chrome değişikliği bir yerleşim okumasından sonra görür (`getClientRects`).
   `useLayoutEffect`: yeni sayfa eski kaydırma konumunda bir kare bile çizilmesin.
   Sayfa içi yumuşak kaydırmalar (bölüm bağlantıları) aynen çalışır. */
function ScrollToTopOnNav() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    if (window.scrollY === 0) return;
    const kok = document.documentElement;
    const onceki = kok.style.scrollBehavior;
    kok.style.scrollBehavior = 'auto';
    kok.getClientRects();
    window.scrollTo(0, 0);
    kok.style.scrollBehavior = onceki;
  }, [pathname]);
  return null;
}

function LandingPage() {
  return (
    <>
      <main>
        <Hero />
        <SectionReveal><Products /></SectionReveal>
        {/* DÖRT ÜRÜNÜN ANİMASYONLU TANITIMI.
            Kart ızgarasının hemen ardında: kartlar "ne var" sorusunu,
            bu bölüm "nasıl görünüyor" sorusunu cevaplıyor. Dönüşümlü
            düzen (anim sol / yazı sol) kendi içinde kurulu; kaydırma
            geçişini kendi içinde `SectionReveal` ile yapıyor, o yüzden
            burada ikinci bir sarmalayıcıya alınmadı — iç içe iki
            IntersectionObserver bölümün iki kez belirmesine yol açardı. */}
        <UrunBolumleri />
        <SectionReveal delay={100}><HowItWorks /></SectionReveal>
        <SectionReveal delay={100}><Features /></SectionReveal>
        <SectionReveal delay={100}><Security /></SectionReveal>
        <SectionReveal delay={100}><FAQ /></SectionReveal>
      </main>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <div className="min-h-screen flex flex-col dark:bg-slate-950 bg-[#f0f4f8] dark:text-white text-slate-900">
            <ScrollToTopOnNav />
            <Navbar />
            <div className="flex-1">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                {/* WhowSell Cloud: rota adı kardeş projelerin dördünde de
                    `/whowsell-cloud`. Aynı yol burada da kullanıldı —
                    crm.whowsell.com/whowsell-cloud adresinden gelen bir
                    kullanıcı whowsell.com'da aynı adreste aynı sayfayı
                    bulur. */}
                <Route path="/whowsell-cloud" element={<CloudPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                {/* Rota adları İngilizce: mevcut /terms, /privacy, /contact
                    ile tutarlı olsun diye. `/data-protection` ayrıca kardeş
                    proje crm-whowsell'deki KVKK rotasıyla da aynı. */}
                <Route path="/cookies" element={<CookiesPage />} />
                <Route path="/data-protection" element={<DataProtectionPage />} />
                <Route path="/contact" element={<ContactPage />} />
                {/* Bilinmeyen adres ana sayfaya (4 Kasım 2026): kaldırılan bir sayfanın
                    eski bağlantısı (arama motoru, eski paylaşım) boş bir sayfa açmasın. */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <Footer />
            <ScrollToTop />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
